import { render, staticRenderFns } from "./BusinessInsights.vue?vue&type=template&id=03bd28f0&scoped=true"
import script from "./BusinessInsights.vue?vue&type=script&lang=js"
export * from "./BusinessInsights.vue?vue&type=script&lang=js"
import style0 from "./BusinessInsights.vue?vue&type=style&index=0&id=03bd28f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd28f0",
  null
  
)

export default component.exports